import { AiOutlineArrowLeft } from "react-icons/ai";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { io } from "socket.io-client";

const GAME_URL = process.env.REACT_APP_GAME_SERVER_URL;

const WaitingRoom = () => {
  const { lobbyCode, tournamentId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [opponent, setOpponent] = useState(null);
  const [status, setStatus] = useState("Waiting for opponent...");

  const tournamentSocket = useMemo(() => {
    if (!user) return null;

    // const tokenStr = sessionStorage.getItem("token");
    // const token = tokenStr && `Bearer ${JSON.parse(tokenStr).accessToken}`;

    const socket = io(`${GAME_URL}/tournament`, {
      autoConnect: true,
      transports: ["websocket", "polling"],
      reconnection: false,
      timeout: 20000,
      pingInterval: 25000,
      pingTimeout: 30000,
      query: {
        userId: user._id,
        tournamentId: tournamentId,
        isOwner: false,
      },    auth: {
        userId: user._id,
        tournamentId: tournamentId,
        isOwner: false,
      },
    });

    return socket;
  }, [user]);

  useEffect(() => {
    if (!user || !lobbyCode || !tournamentSocket) return;

    tournamentSocket.on("connect_error", (err) => {
  console.error("Socket connection error:", err);
  setStatus("Connection error. Returning to previous page...");
  
  setTimeout(() => {
    navigate(-1);
  }, 1500);
});


    // Emit join waiting room
    tournamentSocket.emit("join-tournament-waiting-room", {
      userId: user._id,
      lobbyCode,
    });

    // Check if this is a redirect after fixture → emit tournament-fixture-completed
    const redirectedFromFixture = location.state?.fromFixture === true;
    if (redirectedFromFixture) {
      tournamentSocket.emit("tournament-fixture-completed", user._id);
      console.log("Emitted tournament-fixture-completed");
    }

    // Listen for events
    tournamentSocket.on("opponent-found", (data) => {
      setOpponent(data.opponent);
      setStatus("Opponent found! Waiting for game to start...");
    });

    tournamentSocket.on("start-tournament-fixture", (gameData) => {
      navigate(`/tournament-game/${gameData.gameId}`, {
        state: gameData,
      });
    });

    tournamentSocket.on("opponent-not-active", () => {
      setStatus("Opponent didn’t join, you win!");
    });

    tournamentSocket.on("opponent-not-available", () => {
      setStatus("Opponent not available. Please try again later.");
    });

    tournamentSocket.on("error", (errorData) => {
      console.error("Socket error:", errorData);
      setStatus(`Error: ${errorData.message}`);
    });


    // Cleanup
    return () => {

      // Emit leave waiting room on unmount
      tournamentSocket.emit("leave-tournament-waiting-room", {
        userId: user._id,
        lobbyCode,
      });

      // Remove listeners
      tournamentSocket.off("opponent-found");
      tournamentSocket.off("start-tournament-fixture");
      tournamentSocket.off("opponent-not-active");
      tournamentSocket.off("opponent-not-available");
      tournamentSocket.off("error");
      tournamentSocket.off("connect_error");


      // Disconnect this namespace socket
      tournamentSocket.disconnect();
    };
  }, [user, lobbyCode, navigate, location.state, tournamentSocket]);
  return (
    <div className="min-h-screen bg-[#130828] px-4 text-white">
      <div className="relative flex items-center justify-center py-5">
        <div className="absolute -left-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold text-center">
          Tournament{" "}
          <span className="bg-gradient-to-r from-[#C6BCFF] to-[#ec4899] bg-clip-text text-transparent">
            Waiting Room
          </span>
        </h2>
      </div>

      <div className="flex flex-col items-center justify-between w-full max-w-md gap-4 px-6 rounded-[30px] relative">
        {/* User */}
        <div className="flex flex-col items-center">
          <div className="relative">
            <img
              src={user?.avatar || "https://ui-avatars.com/api/?name=You"}
              alt="Your Avatar"
              className="w-52 p-3 border-8 border-[#E9FFB7] h-52 rounded-full bg-[#FFB1E7]"
            />
            <span className="absolute bottom-20 left-1 -translate-x-1/2 bg-[#1DA1F2] text-white text-lg px-6 py-1 rounded-full">
              You
            </span>
          </div>
          <p className="text-white font-medium mt-2">{user?.firstName}</p>
        </div>

        {/* VS */}
        <p className="text-white font-bold text-4xl">VS</p>

        {/* Opponent */}
        <div className="flex flex-col items-center">
          <div className="relative">
            <img
              src={
                opponent?.avatar ||
                "https://ui-avatars.com/api/?name=Waiting..."
              }
              alt="Opponent Avatar"
              className="w-52 p-3 border-8 border-[#E9FFB7] h-52 rounded-full bg-[#9FD1D7]"
            />
            <span className="absolute bottom-20 -right-40 -translate-x-1/2 bg-[#1DA1F2] text-white text-lg px-6 py-1 rounded-full">
              Opponent
            </span>
          </div>
          <p className="text-white font-medium mt-2">
            {opponent?.name || "Waiting..."}
          </p>
        </div>
      </div>
      

      <div className="mt-10 flex flex-col items-center">
        {/* <p className="text-2xl font-bold text-yellow-400">{timeLeft}s</p> */}
        <p className="text-sm py-4 text-center">{status}</p>
      </div>
    </div>
  );
};

export default WaitingRoom;
